import { Button, Grid, Glyphicon, Row, Col, Table, Tabs, Tab } from "react-bootstrap";
import AlertFlag from "../AlertFlag";
import ImagePreview from "../ImagePreview";
import ImageSetUploader from "../ImageSetUploader";
import Loader from "../Loader";
import QuestionResponseModal from "../QuestionResponseModal";
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite";
import * as managers from "../../lib/api/managers";
import logger from "../../lib/logger";
import PropTypes from "prop-types";

const styles = StyleSheet.create({
    alertFlag: {
        display: "inline-block",
        marginRight: 10,
    },
    tabWrapper: {
        marginTop: 20,
    },
});

const strings = {
    loading: "Loading",
    titleSuffix: "| Habit CMS",
    missingPhoto: "Missing Photo",
    missingQA: "Missing Q+A Responses",
    images: "Images",
    qaResponses: "Q+A Responses",
    question: "Question",
    response: "Response",
    noResponse: "No Response",
    edit: "Edit",
};

export default class ManagerPage extends PureComponent {
    static propTypes = {
        match: PropTypes.object.isRequired,
    };

    state = {
        manager: null,
        loading: true,
        currentQuestion: null,
        showQuestionResponseModal: false,
    };

    componentDidMount() {
        this._isMounted = true;
        document.title = `${strings.loading} ${strings.titleSuffix}`;
        managers
            .getManager(this.props.match.params.managerId)
            .then(resp => {
                if (this._isMounted) {
                    this.setState({ manager: resp, loading: false });
                    document.title = `${resp.name} | ${strings.titleSuffix}`;
                }
            })
            .catch(err => logger.warn(err));
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    _editQuestionResponse = index => {
        this.setState({
            currentQuestion: this.state.manager.questions[index],
            showQuestionResponseModal: true,
        });
    };

    _handleCloseQuestionResponseModal = () => {
        this.setState({ showQuestionResponseModal: false });
    };

    _handleSaveQuestionResponseModal = response => {
        managers
            .addQuestionResponse(this.state.manager.id, this.state.currentQuestion.id, response)
            .then(() =>
                this.setState({
                    showQuestionResponseModal: false,
                    currentQuestion: null,
                    manager: {
                        ...this.state.manager,
                        questions: this.state.manager.questions.map(q => {
                            if (q.id === this.state.currentQuestion.id) {
                                return {
                                    ...q,
                                    response,
                                };
                            }
                            return q;
                        }),
                    },
                }),
            );
    };

    _handleUploadImage = (image, crop) => {
        return managers.addImage(this.state.manager.id, image, crop).then(images =>
            this.setState({
                manager: {
                    ...this.state.manager,
                    images,
                },
            }),
        );
    };

    _renderQuestions = () => {
        if (!this.state.manager.questions) {
            return null;
        }
        return this.state.manager.questions.map((q, i) => {
            return (
                <tr key={q.id}>
                    <td>{q.question}</td>
                    {q.response ? (
                        <td>{q.response}</td>
                    ) : (
                        <td className="danger">
                            <Glyphicon glyph="exclamation-sign" />
                            {strings.noResponse}
                            <Glyphicon glyph="exclamation-sign" />
                        </td>
                    )}
                    <td>
                        <Button bsStyle="primary" onClick={() => this._editQuestionResponse(i)}>
                            {strings.edit}
                        </Button>
                    </td>
                </tr>
            );
        });
    };

    render() {
        if (!this.state.manager) {
            return <Loader />;
        }
        const manager = this.state.manager;
        return (
            <Grid>
                <Row>
                    <form>
                        <Col md={1}>
                            <ImagePreview
                                image={
                                    manager.images && manager.images.length
                                        ? manager.images[0]
                                        : null
                                }
                                height={80}
                            />
                        </Col>
                        <Col md={4}>
                            <h4>{manager.name}</h4>
                            <h5>{manager.title}</h5>
                        </Col>
                        <Col md={7}>
                            {!manager.images ? <AlertFlag label={strings.missingPhoto} /> : null}
                            <AlertFlag label={strings.missingQA} />
                        </Col>
                    </form>
                </Row>
                <Row bsClass="m-t">
                    <Col md={12}>
                        <div className={css(styles.tabWrapper)}>
                            <Tabs defaultActiveKey={1} id="uncontrolled-tab-example">
                                <Tab eventKey={1} title={strings.images}>
                                    <ImageSetUploader
                                        images={
                                            this.state.manager ? this.state.manager.images : null
                                        }
                                        onSubmit={this._handleUploadImage}
                                        minWidth={80}
                                        minHeight={80}
                                    />
                                </Tab>
                                <Tab eventKey={2} title={strings.qaResponses}>
                                    <div className={css(styles.tabWrapper)}>
                                        <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>{strings.question}</th>
                                                    <th>{strings.response}</th>
                                                    <th>{strings.edit}</th>
                                                </tr>
                                            </thead>
                                            <tbody>{this._renderQuestions()}</tbody>
                                        </Table>
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    </Col>
                </Row>
                {this.state.showQuestionResponseModal ? (
                    <QuestionResponseModal
                        key={this.state.currentQuestion ? this.state.currentQuestion.id : null}
                        initialResponse={
                            this.state.currentQuestion ? this.state.currentQuestion.question : null
                        }
                        show={this.state.showQuestionResponseModal}
                        handleClose={this._handleCloseQuestionResponseModal}
                        handleSave={this._handleSaveQuestionResponseModal}
                    />
                ) : null}
            </Grid>
        );
    }
}
